import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

function Payrollpending() {
  const location = useLocation();
  const [uncheckedPayrollData, setUncheckedPayrollData] = useState(() => location.state?.uncheckedPayrollData || []);
  const [searchTerm, setSearchTerm] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState('');
  const [profitCenterFilter, setProfitCenterFilter] = useState('');

  // Log data for debugging
  
  // Get unique departments and profit centers for filter options
  const departments = [...new Set(uncheckedPayrollData.map(item => item.DepartmentName))];
  const profitCenters = [...new Set(uncheckedPayrollData.map(item => item.ProfitcenterName))];

  // Filter data based on search and filter selections
  const filteredData = uncheckedPayrollData.filter(item => {
    const matchesSearch = 
      item.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.Code.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesDepartment = departmentFilter ? item.DepartmentName === departmentFilter : true;
    const matchesProfitCenter = profitCenterFilter ? item.ProfitcenterName === profitCenterFilter : true;
    return matchesSearch && matchesDepartment && matchesProfitCenter;
  });

  // Calculate counts for each department and profit center
  const departmentCounts = departments.reduce((acc, dept) => {
    acc[dept] = uncheckedPayrollData.filter(item => 
      item.DepartmentName === dept &&
      (item.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
       item.Code.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (profitCenterFilter ? item.ProfitcenterName === profitCenterFilter : true)
    ).length;
    return acc;
  }, {});

  const profitCenterCounts = profitCenters.reduce((acc, pc) => {
    acc[pc] = uncheckedPayrollData.filter(item => 
      item.ProfitcenterName === pc &&
      (item.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
       item.Code.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (departmentFilter ? item.DepartmentName === departmentFilter : true)
    ).length;
    return acc;
  }, {});

  // Check if any filters are applied
  const isFilterApplied = searchTerm || departmentFilter || profitCenterFilter;

  // Get current month and year
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString('default', { month: 'long' });
  const currentYear = currentDate.getFullYear();

  return (
    <div className="container mx-auto p-6 bg-gray-100 min-h-screen">
      {/* Header, Count, and Back Button */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">
            Payroll Approval Pending for {currentMonth} {currentYear}
          </h1>
          {!isFilterApplied && (
            <p className="text-lg text-gray-600 mt-2">
              Total Records: {uncheckedPayrollData.length}
            </p>
          )}
        </div>
        <Link 
          to="/" 
          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition"
        >
          Back to Dashboard
        </Link>
      </div>

      {/* Search and Filters */}
      <div className="bg-white p-4 rounded-lg shadow-md mb-6">
        <div className="flex flex-col md:flex-row gap-4">
          {/* Search Input */}
          <input
            type="text"
            placeholder="Search by Name or Code..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full md:w-1/3 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          {/* Department Filter */}
          <select
            value={departmentFilter}
            onChange={(e) => setDepartmentFilter(e.target.value)}
            className="w-full md:w-1/3 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Departments</option>
            {departments.map((dept, index) => (
              <option key={index} value={dept}>
                {dept} ({departmentCounts[dept] || 0})
              </option>
            ))}
          </select>

          {/* Profit Center Filter */}
          <select
            value={profitCenterFilter}
            onChange={(e) => setProfitCenterFilter(e.target.value)}
            className="w-full md:w-1/3 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Profit Centers</option>
            {profitCenters.map((pc, index) => (
              <option key={index} value={pc}>
                {pc} ({profitCenterCounts[pc] || 0})
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow-md overflow-x-auto">
        <table className="w-full table-auto">
          <thead className="">
            <tr>
              <th className="p-3 text-left">Sl No</th>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Code</th>
              <th className="p-3 text-left">Designation</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr 
                  key={item.EmpId} 
                  className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                >
                  <td className="p-3">{index + 1}</td>
                  <td className="p-3">{item.Name}</td>
                  <td className="p-3">{item.Code}</td>
                  <td className="p-3">{item.DesignationName}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="p-3 text-center text-gray-500">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Payrollpending;